import { gql } from "@apollo/client";

export const WARNING = gql`
    query warning {
        warning {
            warningId
            status
            reason
            createdAt

            warningCount
            finalCharge
        }
    }
`;

export const REVIEW_REASONS = gql`
    query reviewReasons {
        reviewReasons {
            text
            order
            reasonId
        }
    }
`;
